import React from 'react';
import UserAdsListing from '../AddUserListing/UserAdsListing';

export default function Ads() {
  return <UserAdsListing />;
}
